import React from "react";
import { ToastContainer } from "react-toastify";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <>
      <ToastContainer />
      <Outlet />
    </>
  );
};

export default AuthLayout;
